module.exports = __webpack_public_path__ + "img/x10.2f31ac63.jpg";